var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.74 0.5H0.240015C0.174583 0.505048 0.113479 0.534654 0.0689654 0.582877C0.0244517 0.6311 -0.000178981 0.694373 1.54489e-05 0.76V1.62C-0.000585379 1.70815 0.0163447 1.79553 0.0498212 1.87708C0.0832977 1.95862 0.132653 2.0327 0.195016 2.095L6.19502 8.095V13.095L9.82001 14.9V8.085L15.82 2.085C15.9348 1.96118 15.999 1.79884 16 1.63V0.76C16 0.691044 15.9726 0.624912 15.9239 0.576152C15.8751 0.527393 15.809 0.5 15.74 0.5Z",
    fill: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.2c14a880c1571b87d8ec73b3e5f97808.svg";
export { ForwardRef as ReactComponent };